var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"page-x flex-all-center",attrs:{"direction":"vertical"}},[_c('div',{staticClass:"mb20",staticStyle:{"font-size":"48px"}},[_vm._v("欢迎使用")]),_c('div',{staticClass:"mb20",staticStyle:{"font-size":"48px"}},[_vm._v("汇晨互动智能健康评估系统")])])
}
var staticRenderFns = []

export { render, staticRenderFns }